import React from "react";
import _ from "lodash";
import { themeGet } from "styled-system";
import styled from "styled-components";
import TextF6 from "../TextF6";
import LikertScale from "likert-react";
import { SmallContainer } from "../Grid";
import Box from "../Box";
import "likert-react/dist/main.css";
import { FormattedMessage } from "react-intl";

const LikertWrapper = styled.div`
  padding: 0;
  .likert-react_src-___styles__container-striped {
    padding: 1rem;
    flex-direction: column;
    font-family: ${themeGet("fonts.TTNormsProRegular")};
    .likert-react_src-review-scale-___styles__scale {
      margin: 0.5rem 0 0 0.3rem;
    }
    .likert-react_src-___styles__question {
      max-width: 100%;
    }
    @media screen and (min-width: 32em) {
      .likert-react_src-___styles__question {
        max-width: 60%;
      }
      .likert-react_src-review-scale-___styles__scale {
        margin: 0 0 0 0.3rem;
      }
      flex-direction: row;
    }
  }
  .likert-react_src-___styles__container-striped:nth-child(odd) {
    background: rgba(255, 255, 255, 0.5);
  }
  .likert-react_src-___styles__container-striped:nth-child(even) {
    background: rgba(255, 255, 255, 0.75);
  }
`;

class PeerReviewFeedback extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      averageReview: {}
    };
  }

  componentDidMount() {
    const { peerReviewsReceived } = this.props;

    if (
      !peerReviewsReceived ||
      (!!peerReviewsReceived && peerReviewsReceived.length === 0)
    ) {
      return;
    }

    const gradesForQuestion = _.reduce(
      peerReviewsReceived.map(review => review.grading),
      (obj, grading) => {
        Object.keys(grading).forEach(key => {
          if (!obj[key]) {
            obj[key] = [];
          }
          obj[key].push(grading[key]);
        });
        return obj;
      },
      {}
    );

    const averageReview = _.reduce(
      gradesForQuestion,
      (result, review, question) => {
        result.push({ question, review });
        return result;
      },
      []
    );

    this.setState({ averageReview });
  }

  render() {
    if (Object.keys(this.state.averageReview).length === 0) {
      return null;
    }

    return (
      <Box bg="#EBE9EF" pb={0}>
        <SmallContainer>
          <TextF6 mt={0} mb={3}>
            <FormattedMessage id="peerreview.feedback" />
          </TextF6>
          <LikertWrapper>
            <LikertScale
              reviews={this.state.averageReview}
              separatorType="striped"
              highlightColor="#19CA94"
            />
          </LikertWrapper>
        </SmallContainer>
      </Box>
    );
  }
}

export default PeerReviewFeedback;
